import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack, vstack } from '@flipster/styled-system/patterns';
import { Usd1Currency, UsdtCurrency, UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

import { competitionBunja } from '../../bunja';

export const FixedPrize = () => {
  const { competitionAtom } = useBunja(competitionBunja);
  const competition = useAtomValue(competitionAtom);
  if (!competition) return null;
  const prizePoolCurrency = competition.competitionUrl === 'usd1-perps-trading-battle' ? Usd1Currency : UsdtCurrency;
  return (
    <div className={stack({ gap: 16, p: 16, bgGradient: 'programs.promotion' })}>
      <div className={vstack({ gap: 4, color: 'content.default.level-5' })}>
        <p className={css({ textStyle: 'Text/M/Strong' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Total_prize_pool' />
        </p>
        <p className={css({ textStyle: 'Title/S/Monospace' })}>
          {numberFormatter(competition.prizePool, { precision: UsdtPrecision, toFixed: true })} {prizePoolCurrency}
        </p>
      </div>
    </div>
  );
};
